exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".el-table .cell{word-break:normal!important}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/admin/Clients/ClientTable.vue"],"names":[],"mappings":"AACA,gBACE,2BAA8B,CAC/B","file":"ClientTable.vue","sourcesContent":["\n.el-table .cell {\n  word-break: normal !important;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1cead2ca","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/Clients/ClientTable.vue
// module id = 974
// module chunks = 11